import { forwardRef, useCallback, useImperativeHandle } from 'react';

import { Flex } from '@chakra-ui/react';
import { IFilterParams } from 'ag-grid-community';

import { Check, CloseIconChip } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { BUTTON_COLORS } from 'uiToolkitV1/Button/Button';

export const AgGridFilterButtons = forwardRef((props: IFilterParams, ref) => {
  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => ({
    doesFilterPass() {
      return true;
    },

    isFilterActive() {
      return false;
    },

    getModel() {},

    setModel() {},
  }));

  const clearFilters = useCallback(() => {
    props.api.setFilterModel(null);
    props.api.applyColumnState({
      state: [{ colId: props.column.getId(), sort: null }],
      defaultState: { sort: null },
    });
    props.api.hidePopupMenu();
  }, [props.api, props.column]);

  const closeMenu = useCallback(() => {
    props.api.hidePopupMenu();
  }, [props.api]);

  return (
    <Flex margin="-1px" justifyContent="space-between" borderTopWidth="1px" borderTopColor="neutral.CFD7DF" pt={1}>
      <Button onClick={clearFilters} variant="tertiary" StartIcon={CloseIconChip} color={BUTTON_COLORS.red}>
        Clear All
      </Button>
      <Button onClick={closeMenu} variant="tertiary" StartIcon={Check}>
        Apply
      </Button>
    </Flex>
  );
});
